"use client";

import Link from "next/link";
import MediaComponent from "@core/helpers/client/components/image";
import SwiperComponent from "@/components/ui/swiper-component";
import Title from "../Title";
import DeviceOnly from "@/components/DeviceOnly";

function BrandCard({ item, storage_prefix_url }) {

    return (
        <Link
            href={item?.seo?.full_url || "#"}
            className="flex flex-col items-center justify-center w-full border-l border-neutral-100"
        >
            <div className="h-[72px] lg:h-[100px] aspect-square mx-4 lg:mx-6 overflow-hidden">
                <MediaComponent
                    src={item?.media?.url || ""}
                    // نام برند زیر لوگو نوشته شده؛ alt هم‌متن آن باعث می‌شود screen reader برند را دوبار بخواند
                    alt=""
                    width={100}
                    height={100}
                    // باکس لوگو ۷۲px موبایل / ۱۰۰px دسکتاپ؛ بدون sizes فایل ۷۵۰px دانلود می‌شد
                    sizes="100px"
                    style={{ width: "100%", height: "100%" }}
                    storage_prefix_url={storage_prefix_url}
                    image_className="w-full h-full object-contain p-1"
                />
            </div>

            <span className="font-bold text-sm lg:text-base text-jmt-neutral-700 whitespace-nowrap mt-2">
                {item?.title}
            </span>
        </Link>
    );
}

export default function HomePopularBrands({ fields, storage_prefix_url, collection_data }) {

    const brands = collection_data?.brands

    return (
        <>
            <DeviceOnly on="mobile">
                <div className="block lg:hidden w-full mx-auto">

                    {/* Header Section */}
                    <div className="flex items-center text-jmt-main px-4 md:px-10 pb-4 gap-1">
                        <div className="text-editor-svg" dangerouslySetInnerHTML={{
                            __html: fields?.icon
                        }} />

                        <Title type={fields?.title?.type} className="font-bold text-base lg:text-xl">
                            {fields?.title?.title || ""}
                        </Title>
                    </div>

                    <SwiperComponent
                        slides={brands?.length > 0 ? brands.map((item) => (
                            <BrandCard
                                key={item.id}
                                item={item}
                                storage_prefix_url={storage_prefix_url}
                            />)) : []}
                        slidesPerView={2.8}
                        loop={false}
                        hideNavOnMobile={true}
                        navigation={true}
                        navPosition="sides"
                        swiper_className="px-4! md:px-10!"
                        breakpoints={{
                            400: { slidesPerView: 3.5, spaceBetween: 12 },
                            500: { slidesPerView: 4.5, spaceBetween: 12 },
                            768: { slidesPerView: 5.5, spaceBetween: 20 },
                            868: { slidesPerView: 6.5, spaceBetween: 22 },
                            968: { slidesPerView: 7.5, spaceBetween: 24 },
                            1200: { slidesPerView: 8.5, spaceBetween: 24 },
                        }}
                    />
                </div>
            </DeviceOnly>

            <DeviceOnly on="desktop">
                <div className="hidden lg:block">
                    <div className="container">

                        {/* Header Section */}
                        <div className="flex items-center text-jmt-main pb-2 lg:pb-4 gap-1 lg:gap-2">
                            <div className="text-editor-svg" dangerouslySetInnerHTML={{
                                __html: fields?.icon
                            }} />

                            <Title type={fields?.title?.type} className="font-bold text-base lg:text-xl">
                                {fields?.title?.title || ""}
                            </Title>
                        </div>

                        <SwiperComponent
                            slides={brands?.length > 0 ? brands.map((item) => (
                                <BrandCard
                                    key={item.id}
                                    item={item}
                                    storage_prefix_url={storage_prefix_url}
                                />)) : []}
                            slidesPerView={2.8}
                            loop={false}
                            hideNavOnMobile={true}
                            navigation={true}
                            navPosition="sides"
                            breakpoints={{
                                400: { slidesPerView: 3.5, spaceBetween: 12 },
                                500: { slidesPerView: 4.5, spaceBetween: 12 },
                                768: { slidesPerView: 5.5, spaceBetween: 20 },
                                868: { slidesPerView: 6.5, spaceBetween: 22 },
                                968: { slidesPerView: 7.5, spaceBetween: 24 },
                                1200: { slidesPerView: 8.5, spaceBetween: 24 },
                            }}
                        />
                    </div>
                </div>
            </DeviceOnly>
        </>
    );
}
